(function () {
  function normalizeContactPath() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path !== '/contact') return false;

    var hash = window.location.hash;
    if (hash === '#tcb-finder-lead-form' || hash === '#tcb-finder-lead-capture' || !hash) {
      hash = '#tcb-contact-form';
    }
    var search = window.location.search || '';
    if (hash === '#tcb-contact-form' && search.indexOf('topic=') === -1) {
      search += (search ? '&' : '?') + 'topic=equipment-finder';
    }
    window.location.replace('/pages/contact' + search + hash);
    return true;
  }

  function recoverFromShopifyError() {
    var text = document.body && document.body.textContent || '';
    if (!text) return false;

    if (text.indexOf('Missing CAPTCHA token') !== -1 || text.indexOf('Something went wrong') !== -1) {
      var target = '/collections/all';
      if (text.indexOf('CAPTCHA') !== -1) {
        target = '/pages/contact?topic=expert-help#tcb-contact-form';
      }
      window.location.replace(target);
      return true;
    }
    return false;
  }

  function fixNotFoundPage() {
    var root = document.querySelector('.tcb-not-found');
    if (!root) return;

    var imgs = root.querySelectorAll('.tcb-not-found-hero__vacuum, .tcb-not-found-hero__scrubber, .tcb-not-found-card__media img');
    if (!imgs.length) return;

    var fallbacks = {
      vacuum: 'https://thecleaningbusiness.com/cdn/shop/t/9/assets/tcb-cat-commercial-vacuums.png',
      scrubber: 'https://thecleaningbusiness.com/cdn/shop/t/9/assets/tcb-ef-scrubber-action.png'
    };

    imgs.forEach(function (img) {
      function applyFallback() {
        if (img.dataset.tcb404Fixed === '1') return;
        img.dataset.tcb404Fixed = '1';
        img.removeAttribute('srcset');
        if (img.classList.contains('tcb-not-found-hero__vacuum')) {
          img.src = fallbacks.vacuum;
        } else if (img.classList.contains('tcb-not-found-hero__scrubber')) {
          img.src = fallbacks.scrubber;
        }
      }

      if (!img.complete || img.naturalWidth === 0) applyFallback();
      img.addEventListener('error', applyFallback);
    });
  }

  function injectAiaHeroSlideshowCss() {
    if (document.getElementById('tcb-aia-hero-slideshow-css')) return;
    var style = document.createElement('style');
    style.id = 'tcb-aia-hero-slideshow-css';
    style.textContent =
      '.tcb-aia-hero__slideshow{position:relative;aspect-ratio:16/9;min-height:220px}' +
      '.tcb-aia-hero__slide{position:absolute;inset:0;opacity:0;z-index:0;transition:opacity .6s ease}' +
      '.tcb-aia-hero__slide.is-active{opacity:1;z-index:1}' +
      '.tcb-aia-hero__slideshow:not(.is-js-controlled) .tcb-aia-hero__slide:nth-child(1){animation:tcbAiaHeroSlide1 7.5s infinite}' +
      '.tcb-aia-hero__slideshow:not(.is-js-controlled) .tcb-aia-hero__slide:nth-child(2){animation:tcbAiaHeroSlide2 7.5s infinite}' +
      '.tcb-aia-hero__slideshow:not(.is-js-controlled) .tcb-aia-hero__slide:nth-child(3){animation:tcbAiaHeroSlide3 7.5s infinite}' +
      '.tcb-aia-hero__slideshow .tcb-aia-hero__frame img,.tcb-aia-hero__slide img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.tcb-aia-hero__dots{position:absolute;left:50%;bottom:12px;transform:translateX(-50%);display:flex;gap:8px;padding:6px 10px;border-radius:999px;background:rgba(16,35,63,.45);z-index:2}' +
      '.tcb-aia-hero__dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.45)}' +
      '.tcb-aia-hero__dot.is-active{background:#fff;transform:scale(1.15)}' +
      '@keyframes tcbAiaHeroSlide1{0%,26%{opacity:1;z-index:2}33%,100%{opacity:0;z-index:0}}' +
      '@keyframes tcbAiaHeroSlide2{0%,26%{opacity:0}33%,59%{opacity:1;z-index:2}66%,100%{opacity:0;z-index:0}}' +
      '@keyframes tcbAiaHeroSlide3{0%,59%{opacity:0}66%,92%{opacity:1;z-index:2}100%{opacity:0;z-index:0}}';
    document.head.appendChild(style);
  }

  function initAiaHeroSlideshowJs(container) {
    if (!container || container.classList.contains('is-js-controlled')) return;
    var slides = container.querySelectorAll('[data-tcb-aia-hero-slide]');
    var dots = container.querySelectorAll('[data-tcb-aia-hero-dot]');
    if (slides.length < 2) return;
    container.classList.add('is-js-controlled');
    var index = 0;
    var intervalMs = parseInt(container.getAttribute('data-interval') || '2500', 10) || 2500;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
    var timer = window.setInterval(function () {
      show(index + 1);
    }, intervalMs);
    container.addEventListener('mouseenter', function () {
      window.clearInterval(timer);
    });
    container.addEventListener('mouseleave', function () {
      timer = window.setInterval(function () {
        show(index + 1);
      }, intervalMs);
    });
  }

  function recoverAiaHeroSlideshow() {
    if (!/\/pages\/cleaning-equipment-advisor/.test(window.location.pathname)) return;
    if (document.querySelector('[data-tcb-aia-hero-slideshow]')) {
      injectAiaHeroSlideshowCss();
      initAiaHeroSlideshowJs(document.querySelector('[data-tcb-aia-hero-slideshow]'));
      return;
    }

    var root = document.querySelector('[data-tcb-ai-advisor-landing]');
    var sectionEl = root && root.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;

    var key = sectionEl.id.replace('shopify-section-', '');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(key) + '&cb=' + Date.now(), {
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var fresh = data && data[key];
        if (!fresh || fresh.indexOf('data-tcb-aia-hero-slideshow') === -1) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = fresh;
        var freshRoot = wrap.querySelector('[data-tcb-ai-advisor-landing]');
        if (!freshRoot || !root) return;
        var freshHero = freshRoot.querySelector('.tcb-aia-hero__media');
        var oldHero = root.querySelector('.tcb-aia-hero__media');
        if (!freshHero || !oldHero) return;
        oldHero.replaceWith(freshHero);
        injectAiaHeroSlideshowCss();
        initAiaHeroSlideshowJs(root.querySelector('[data-tcb-aia-hero-slideshow]'));
        document.dispatchEvent(new CustomEvent('tcb:aia-hero-updated'));
      })
      .catch(function () {
        /* ignore */
      });
  }

  function loadScriptOnce(src) {
    return new Promise(function (resolve, reject) {
      var needle = src.split('/').pop().split('?')[0];
      if (document.querySelector('script[src*="' + needle + '"]')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  function loadStylesheetOnce(href) {
    if (document.querySelector('link[href*="' + href.split('/').pop().split('?')[0] + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function collectAssetUrls(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var styles = [];
    var scripts = [];
    wrap.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (link) {
      styles.push(link.getAttribute('href'));
    });
    wrap.querySelectorAll('script[src]').forEach(function (script) {
      scripts.push(script.getAttribute('src'));
    });
    return { styles: styles, scripts: scripts };
  }

  function initEquipmentFinderRoots() {
    if (window.TCBEquipmentFinderInit) {
      window.TCBEquipmentFinderInit();
      return;
    }
    document.querySelectorAll('[data-tcb-equipment-finder]').forEach(function (root) {
      if (root.__finder) return;
      document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: root.closest('[id^="shopify-section-"]') } }));
    });
  }

  function recoverEquipmentFinderQuiz() {
    if (!/\/pages\/equipment-finder-quiz/.test(window.location.pathname)) return;
    if (document.querySelector('[data-tcb-equipment-finder]')) return;

    var main = document.getElementById('main');
    var sectionEl = main && main.querySelector('.shopify-section');
    if (!sectionEl || !sectionEl.id) return;

    var key = sectionEl.id.replace('shopify-section-', '');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(key) + '&cb=' + Date.now(), {
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var fresh = data && data[key];
        if (!fresh || fresh.indexOf('data-tcb-equipment-finder') === -1) return;

        var assets = collectAssetUrls(fresh);
        assets.styles.forEach(function (href) {
          if (href) loadStylesheetOnce(href.indexOf('//') === 0 ? 'https:' + href : href);
        });

        var wrap = document.createElement('div');
        wrap.innerHTML = fresh;
        var freshSection = wrap.firstElementChild;
        if (!freshSection) return;
        sectionEl.replaceWith(freshSection);

        var scriptLoads = assets.scripts.map(function (src) {
          if (!src) return Promise.resolve();
          return loadScriptOnce(src.indexOf('//') === 0 ? 'https:' + src : src);
        });

        Promise.all(scriptLoads)
          .then(function () {
            initEquipmentFinderRoots();
            document.dispatchEvent(new CustomEvent('tcb:finder-quiz-recovered'));
          })
          .catch(function () {
            initEquipmentFinderRoots();
          });
      })
      .catch(function () {
        /* ignore */
      });
  }

  if (normalizeContactPath()) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      recoverFromShopifyError();
      fixNotFoundPage();
      recoverEquipmentFinderQuiz();
      recoverAiaHeroSlideshow();
    });
  } else {
    recoverFromShopifyError();
    fixNotFoundPage();
    recoverEquipmentFinderQuiz();
    recoverAiaHeroSlideshow();
  }
})();
